import {sanitizeRichTextHtml} from './utils.js'

// Converts (sanitized) rich-text HTML into a plain-text block suitable for the PDF export:
// tables become "cell | cell" rows, list items get a leading "- ", and runs of blank lines collapse.
export function toPlainText(value) {
  const sanitized = sanitizeRichTextHtml(value || '')
  if (!sanitized) {
    return ''
  }
  const parser = new DOMParser()
  const doc = parser.parseFromString(`<div>${sanitized}</div>`, 'text/html')
  const root = doc.body.firstElementChild || doc.body
  transformTablesToPlainRows(doc, root)
  prefixListItems(root)

  const rawText = root.innerText || root.textContent || ''

  const normalizedLines = []
  let previousLineEmpty = false
  for (const rawLine of rawText.replace(/\r\n/g, '\n').split('\n')) {
    const line = normalizePdfLine(rawLine)
    if (!line) {
      if (!previousLineEmpty && normalizedLines.length > 0) {
        normalizedLines.push('')
      }
      previousLineEmpty = true
    } else {
      normalizedLines.push(line)
      previousLineEmpty = false
    }
  }

  return normalizedLines.join('\n').trim()
}

function normalizePdfLine(line) {
  return (line || '')
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+/g, ' ')
    .trim()
}

function transformTablesToPlainRows(doc, root) {
  const tables = Array.from(root.querySelectorAll('table'))
  tables.forEach(table => {
    const rowLines = Array.from(table.querySelectorAll('tr'))
      .map(row => {
        const cells = Array.from(row.querySelectorAll('th,td'))
          .map(cell => normalizePdfLine(cell.textContent || ''))
          .filter(Boolean)
        return cells.join(' | ')
      })
      .filter(Boolean)
    const replacementText = rowLines.join('\n')
    const replacement = doc.createTextNode(replacementText)
    table.replaceWith(replacement)
  })
}

function prefixListItems(root) {
  const listItems = Array.from(root.querySelectorAll('li'))
  listItems.forEach(item => {
    const text = item.textContent || ''
    if (text.trim().startsWith('-')) {
      return
    }
    item.insertBefore(item.ownerDocument.createTextNode('- '), item.firstChild)
  })
}
